module.exports = __webpack_public_path__ + "img/englishAchievement.32008f6e.jpg";